// extracted by mini-css-extract-plugin
module.exports = {"groupCollapse":"groupCollapse--1clN7","collapsibleAvatar":"collapsibleAvatar--7YkMG"};